import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { useCreateSemen } from '../contexts/semen';
import { validateSemen } from '../utils/validate';
import { buildSemenPayload } from '../utils/payload';
import SemenFields from './fields';

import '../../../common/styles/catalog.css';

const EMPTY = {
    code: '', name: '', race_id: '', origin: '', supplier: '',
    codeTouched: false, nameTouched: false, raceTouched: false,
    sireMode: 'existing',          // 'existing' (sire_animal_id) | 'new' (sire_animal anidado)
    sireAnimal: null,              // toro existente elegido
    newName: '', newRegister: '', newRace: '', // toro de referencia anidado
};

export default function CreateSemenForm() {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCreateSemen();

    const [form, setForm] = useState(EMPTY);
    const [localErrors, setLocalErrors] = useState({});
    const [serverFields, setServerFields] = useState({});

    const setField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        if (localErrors[field] || serverFields[field]) {
            setLocalErrors(prev => ({ ...prev, [field]: undefined }));
            setServerFields(prev => ({ ...prev, [field]: undefined }));
        }
    };
    const fieldError = (field) => localErrors[field] || serverFields[field];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateSemen(form);
        if (Object.keys(errors).length) { setLocalErrors(errors); toast.error('Revisá los campos marcados'); return; }
        setLocalErrors({});
        setServerFields({});

        try {
            await mutateAsync(buildSemenPayload(form));
            toast.success('Semen creado');
            navigate('/admin/semen');
        } catch (err) {
            if (err?.status === 409) toast.error(err?.message || 'El código de semen o el registro del toro ya existen');
            else if (err?.fields) { setServerFields(err.fields); toast.error('Revisá los campos marcados'); }
            else if (err?.status === 422) toast.error(err?.message || 'Elegí o creá el toro (padre)');
            else toast.error(err?.message || 'No se pudo crear el semen');
        }
    };

    return (
        <form className="cat-form" onSubmit={handleSubmit}>
            <header className="cat-form__header">
                <Link to="/admin/semen" className="cat-form__back">Semen</Link>
                <h1 className="cat-form__title">Nuevo semen</h1>
            </header>

            <SemenFields form={form} setField={setField} fieldError={fieldError} disabled={isPending} />

            <footer className="cat-form__footer">
                <Link to="/admin/semen" className="cat-form__cancel">Cancelar</Link>
                <button type="submit" className="cat-form__submit" disabled={isPending || !form.code.trim()}>
                    {isPending ? 'Creando…' : 'Crear semen'}
                </button>
            </footer>
        </form>
    );
}
